import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from "react"; //Limitless imports

import { log as pilog } from "../../../common/utils";
import { useCustomerMessageContext } from "../customer-message/CustomerMessageContext"; // Real Time Enpoint event types

var MESSAGE_EVENT_CLAIM = "claim";
var MESSAGE_EVENT_UNCLAIM = "unclaim";
var MESSAGE_EVENT_NEW_DIALOGUE = "new";
var MESSAGE_EVENT_EXPIRED = "expired";
var MESSAGE_EVENT_REPORTED = "report";
var MESSAGE_EVENT_UNREPORTED = "unreport";
var MESSAGE_EVENT_CLOSED = "close";
var MESSAGE_EVENT_FORWARD = "forward";
var MESSAGE_EVENT_CONFIRMATION = "custConfirmation";
var MESSAGE_EVENT_LIFECYCLE_STATE = "lifecycleState";
var MESSAGE_EVENT_RELEASE = "release";
export var useCustomerWebSockets = function useCustomerWebSockets() {
  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      localClient = _React$useState2[0],
      setLocalClient = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      subscribedMessageId = _React$useState4[0],
      setSubscribedMessageId = _React$useState4[1];

  var _useCustomerMessageCo = useCustomerMessageContext(),
      message = _useCustomerMessageCo.message,
      fetchMessage = _useCustomerMessageCo.fetchMessage,
      setTyping = _useCustomerMessageCo.setTyping,
      clearTyping = _useCustomerMessageCo.clearTyping;

  var messageId = message.messageId,
      accessKey = message.accessKey;
  var log = pilog.getLogger("CustomerWebSockets useCustomerWebSockets");
  React.useEffect(function () {
    log.debug({
      messageId: messageId,
      subscribedMessageId: subscribedMessageId
    });

    if (localClient && messageId && subscribedMessageId !== messageId) {
      var stage = process.env.REACT_APP_WS_STAGE;
      var messageTopic = "flo-public-".concat(stage, "-").concat(message.messageId);
      localClient.subscribe(messageTopic);
      log.info("Successfully subscribed to message topic: ", messageTopic); // if the previousMessageId existed, unsubscribe

      if (subscribedMessageId) {
        localClient.unsubscribe("flo-public-".concat(stage, "-").concat(subscribedMessageId));
        log.info("Successfully unsubscribed to topic: ", subscribedMessageId);
      }

      setSubscribedMessageId(messageId);
    }
  }, [messageId, localClient]);

  var processWebSocketEvent = function processWebSocketEvent(event) {
    if (process.env.REACT_APP_WS_HISTORY) {
      window.wsEvents.push({
        payload: event,
        message: message
      });
    }

    switch (event.action) {
      case MESSAGE_EVENT_CLAIM:
        {
          var claimer = event.payload.name ? event.payload.name : "";
          setTyping(claimer, event.payload.userId);
          break;
        }

      case MESSAGE_EVENT_UNCLAIM:
        clearTyping();
        break;

      case MESSAGE_EVENT_NEW_DIALOGUE:
      case MESSAGE_EVENT_RELEASE:
      case MESSAGE_EVENT_LIFECYCLE_STATE:
      case MESSAGE_EVENT_CONFIRMATION:
      case MESSAGE_EVENT_CLOSED:
      case MESSAGE_EVENT_EXPIRED:
      case MESSAGE_EVENT_FORWARD:
      case MESSAGE_EVENT_REPORTED:
        {
          if (messageId && accessKey) {
            fetchMessage(messageId, accessKey);
          }

          break;
        }

      case MESSAGE_EVENT_UNREPORTED:
        {
          var _messageId = message.messageId,
              _accessKey = message.accessKey,
              state = message.state,
              escalationAgreed = message.escalationAgreed;

          if ((state !== "closed" || escalationAgreed) && _messageId === event.payload.messageId) {
            fetchMessage(_messageId, _accessKey);
          }

          break;
        }

      default:
        log.info("Unspported action ", event);
    }
  };

  var onConnect = function onConnect(client, isReconnect) {
    if (isReconnect && messageId) {
      //this situation is for people who's network connection has dropped
      fetchMessage(messageId, accessKey);
    }

    setLocalClient(client);
  };

  var onDisconnect = function onDisconnect(client) {
    try {
      client.disconnect();
      setLocalClient(null);
    } catch (error) {
      log.info("Failed to disconnect from web sockets %o", error);
    }
  };

  return {
    onConnect: onConnect,
    onDisconnect: onDisconnect,
    processWebSocketEvent: processWebSocketEvent
  };
};